import styled from 'styled-components';

import { gridSizes } from 'utils/style';

import RecurringOrderSuggestionsDiscardReasonsModal from 'components/RecurringOrderSuggestionsDiscardReasonsModal/container';

export default styled(RecurringOrderSuggestionsDiscardReasonsModal)`
  & {
    padding: ${gridSizes('L')};
    padding-bottom: ${gridSizes('S')};
    display: flex;
    flex-direction: column;
  }
`;
